<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">
        {{ $t("room.title") }}
      </strong>
      <a href="/room/create">
        <a-button type="primary" icon="plus-circle" style="float: right">
          {{ $t("room.new") }}
        </a-button>
      </a>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-table
              :columns="columns"
              :rowKey="(record) => record.id"
              :dataSource="data"
              :loading="loading"
            >
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="(c) => (searchInput = c)"
                  :placeholder="`Search UID ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  @change="
                    (e) =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  >Search</a-button
                >
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                  >Reset</a-button
                >
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
              <template slot="stt" slot-scope="id, record, index">
                {{ index + 1 }}
              </template>
              <template slot="name" slot-scope="title, record">
                <router-link :to="`/room/update/${record.id}`">{{
                  record.name || record.id
                }}</router-link>
              </template>
              <template slot="online" slot-scope="online">
                {{ online }}
              </template>
              <template slot="startDate" slot-scope="startDate">
                {{ startDate }}
              </template>
              <template slot="endDate" slot-scope="endDate">
                {{ endDate }}
              </template>
              <template slot="type" slot-scope="type">
                {{
                  type === "speed-dating" ? "Speed dating" : "Dating tonight"
                }}
              </template>
              <template slot="action" slot-scope="record">
                <span>
                  <router-link :to="`/statistics/${record.id}`">
                  <span style="color: #ff5254"> Statistic </span>
                </router-link>
                  |
                 <router-link :to="`/room/${record.id}`">
                  <span style="color: #ff5254"> Matched </span>
                </router-link>
                
                </span>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    const columns = [
      {
        title: "#",
        width: "50px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" },
      },
      {
        title: "Room",
        dataIndex: "room",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "name",
        },
        // onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            }, 0);
          }
        },
      },
      {
        title: "User Online",
        dataIndex: "online",
        width: "15%",
        scopedSlots: { customRender: "online" },
      },

      {
        title: "Start Date",
        dataIndex: "startDate",
        width: "20%",
        scopedSlots: { customRender: "startDate" },
      },
      {
        title: "End Date",
        dataIndex: "endDate",
        width: "20%",
        scopedSlots: { customRender: "endDate" },
      },
      {
        title: "Room Type",
        dataIndex: "type",
        width: "20%",
        scopedSlots: { customRender: "type" },
      },
      {
        title: "Action",
        dataIndex: "",
        width: "25%",
        scopedSlots: { customRender: "action" },
      },
    ];
    return {
      columns,
      data: [],
      loading: false,
    };
  },
  methods: {
    async loadData(user = "") {
      this.loading = true;
      await this.api("admin/room?user=" + encodeURIComponent(user.trim()))
        .then(async (res) => {
          // this.data = res;
          this.data = res.sort(function (a, b) {
            return (
              new Date(b.endDate).getTime() - new Date(a.endDate).getTime()
            );
          });

          console.log("Du lieu", this.data);
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    handleSearch(selectedKeys, confirm) {
      console.log(selectedKeys);
      confirm();
      this.loadData(selectedKeys[0]);
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
</style>
